import { render } from "./ExPagantesFilters.vue?vue&type=template&id=33daef35"
import script from "./ExPagantesFilters.vue?vue&type=script&lang=js"
export * from "./ExPagantesFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__